import React from 'react'
import ShopList from '../components/ShopList'

const Shop = () => {
  return (
    <>
        <ShopList />
    </>
  )
}

export default Shop